import { RadioboxGroup, Radiobox } from '@lemon8/design';
import React, { useEffect } from 'react';
import { FieldProps } from '../type/form';
import { FormContext, FormItem } from '../../form';

import './style.scss';

export function FormRadio(props: FieldProps) {
  const { name, label, tip, className = 'form-radio', required, group, rules, options = [], defaultValue = '' } = props;

  const { state, dispatch } = React.useContext(FormContext);

  useEffect(() => {
    dispatch({ name, type: 'change', payload: defaultValue });
  }, []);

  const handleChange = (_value: string | number) => {
    dispatch({ name, type: 'change', payload: _value });
  };

  return (
    <FormItem
      {...{
        name,
        label,
        tip,
        className,
        required,
        rules,
        group,
      }}
      className="formitem-radiobox-container"
    >
      <RadioboxGroup defaultValue={defaultValue as any} onChange={handleChange} name={name}>
        {/* @ts-ignore */}
        {options.map((item, index) => {
          const { values } = state;
          const checked = values[name] === item.symbol;
          return (
            // @ts-ignore
            <Radiobox
              className="radiobox-item"
              type="normal"
              disabled={false}
              align="left"
              certainHeight={false}
              value={item.symbol}
              key={index}
              checked={checked}
            >
              <div className="content">{item.label}</div>
            </Radiobox>
          );
        })}
      </RadioboxGroup>
    </FormItem>
  );
}
